module.exports = __webpack_public_path__ + "img/audio.e4de55cd.svg";